export const PG_EMAIL_ALT = 'Email us at ';
export const FOOTER_LINKS = [
  { text: 'Security & Trust', href: '/about/trust' },
  { text: 'Privacy', href: '/about/privacy' },
  { text: 'Terms of Services', href: '/about/terms' },
];

export const BBB_IMG_URL = 'https://static.policygenius.com/svgs/bbb.svgz';
export const BBB_IMG_ALT = 'Policygenius is a BBB Accredited Business';
export const QUESTIONS_TEXT = 'Questions?';
